import { render, staticRenderFns } from "./step-3.vue?vue&type=template&id=613504f8&scoped=true&"
import script from "./step-3.vue?vue&type=script&lang=js&"
export * from "./step-3.vue?vue&type=script&lang=js&"
import style0 from "./step-3.vue?vue&type=style&index=0&id=613504f8&lang=scss&scoped=true&"
import style1 from "./step-3.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./step-3.vue?vue&type=style&index=2&id=613504f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613504f8",
  null
  
)

export default component.exports